import PropTypes from 'prop-types'
import React, { Component } from "react"

import { connect } from "react-redux"
import { withRouter } from "../../components/Common/withRouter"

import * as url from "../../helpers/url_helper"
import { API_URL } from "../../helpers/api_helper";

import {
    apiError,
    loginUser,
    socialLogin,
    appleSocialLogin,
    googleSocialLogin,
    facebookSocialLogin,
} from "../../store/actions"

import logo from "../../assets/images/VeeperLogo.svg"

class Login extends Component {
    constructor(props) {
        super(props)
        const savedEmail = localStorage.getItem("veeperRememberEmail") || ""
        this.state = {
            loginError: null,
            showPassword: false,
            isLoading: false,
            rememberMe: !!savedEmail,
            email: savedEmail,
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    handleValidSubmit(event) {
        event.preventDefault();
        this.setState({ loginError: null, isLoading: true });

        const formData = new FormData(event.target);
        const email = formData.get('email');
        const values = {
            email,
            password: formData.get('password')
        };

        if (this.state.rememberMe) {
            localStorage.setItem("veeperRememberEmail", email);
        } else {
            localStorage.removeItem("veeperRememberEmail");
        }

        fetch(`${API_URL}${url.POST_FAKE_JWT_LOGIN}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                "access-control-allow-origin": "*",
                'Access-Control-Allow-Credentials': 'true',
                "Content-type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(values)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else if (res.status === 401) {
                    throw new Error("Invalid email or password")
                } else {
                    throw new Error(res.statusText)
                }
            })
            .then(resData => {
                const { data: { accessToken } } = resData;
                const token_authorization = `Bearer ${accessToken}`;
                localStorage.setItem("veeperAuthToken", JSON.stringify(token_authorization));
                this.props.loginUser(values, this.props.history);
            }).catch((error) => {
                this.setState({
                    loginError: error.message || "Login failed. Please try again.",
                    isLoading: false,
                })
            });
    }

    componentDidMount() {
        this.props.apiError("")
    }

    render() {
        const { loginError, showPassword, isLoading, rememberMe, email } = this.state
        const errorMsg = loginError || this.props.error

        return (
            <React.Fragment>
                <div className="v-login">
                    {/* Left panel */}
                    <div className="v-login-left">
                        <div className="v-left-brand">
                            <div className="v-left-brand-icon">
                                <img src={logo} alt="" height="18" />
                            </div>
                            <span className="v-left-brand-name">Veeper</span>
                        </div>

                        <h1 className="v-left-heading">
                            Admin Panel for<br />Shopify Store Management
                        </h1>
                        <p className="v-left-desc">
                            Monitor revenue recovery, manage coupon blocking, and control
                            store configurations from a single dashboard.
                        </p>

                        <div className="v-left-stats">
                            <div>
                                <div className="v-stat-num">99.9%</div>
                                <div className="v-stat-label">Uptime</div>
                            </div>
                            <div>
                                <div className="v-stat-num">24/7</div>
                                <div className="v-stat-label">Monitoring</div>
                            </div>
                            <div>
                                <div className="v-stat-num">Real-time</div>
                                <div className="v-stat-label">Analytics</div>
                            </div>
                        </div>

                        <div className="v-left-footer">
                            &copy; {new Date().getFullYear()} Veeper &middot; Real Life Apps
                        </div>
                    </div>

                    {/* Right panel */}
                    <div className="v-login-right">
                        <div className="v-form-box">
                            <div className="v-mobile-brand">
                                <div className="v-mobile-icon">
                                    <img src={logo} alt="" height="18" />
                                </div>
                                <span className="v-mobile-name">Veeper</span>
                            </div>

                            <h2 className="v-form-title">Sign in</h2>
                            <p className="v-form-subtitle">Enter your credentials to access the admin panel</p>

                            <form onSubmit={this.handleValidSubmit}>
                                {errorMsg && (
                                    <div className="v-error">
                                        <i className="mdi mdi-alert-circle-outline" />
                                        <span>{errorMsg}</span>
                                    </div>
                                )}

                                <div className="v-field">
                                    <label className="v-label" htmlFor="email">Email</label>
                                    <div className="v-input-wrap">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            className="v-input"
                                            placeholder="admin@veeper.com"
                                            autoComplete="email"
                                            required
                                            defaultValue={email}
                                        />
                                    </div>
                                </div>

                                <div className="v-field">
                                    <label className="v-label" htmlFor="password">Password</label>
                                    <div className="v-input-wrap">
                                        <input
                                            id="password"
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            className="v-input v-input-pw"
                                            placeholder="Enter password"
                                            autoComplete="current-password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="v-pw-btn"
                                            onClick={() => this.setState({ showPassword: !showPassword })}
                                            tabIndex={-1}
                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                        >
                                            <i className={`mdi ${showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}`} />
                                        </button>
                                    </div>
                                </div>

                                <div className="v-options">
                                    <label className="v-check">
                                        <input
                                            type="checkbox"
                                            checked={rememberMe}
                                            onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                                        />
                                        <span>Remember me</span>
                                    </label>
                                </div>

                                <button type="submit" className="v-btn" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <div className="v-spinner" />
                                            Signing in...
                                        </>
                                    ) : (
                                        "Sign In"
                                    )}
                                </button>
                            </form>

                            <div className="v-m-footer">
                                &copy; {new Date().getFullYear()} Veeper &middot; Real Life Apps
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

Login.propTypes = {
    apiError: PropTypes.any,
    error: PropTypes.any,
    history: PropTypes.object,
    loginUser: PropTypes.func,
    socialLogin: PropTypes.func,
    facebookSocialLogin: PropTypes.func,
    googleSocialLogin: PropTypes.func,
    appleSocialLogin: PropTypes.func
}

const mapStateToProps = state => {
    const { error } = state.Login
    return { error }
}

export default withRouter(
    connect(mapStateToProps, { loginUser, apiError, socialLogin, facebookSocialLogin, googleSocialLogin, appleSocialLogin })(Login)
)
